import moment from 'moment-timezone'
import 'moment/locale/de'

import tzs from '../assets/timezones/timezones'

import { defaultLanguage } from './languages'

const defaultTimezone = 'UTC'

// All timezones.
const timezones = tzs

// Converts the given Unix time to a date in the given timezone, in the given format and in the given language.
const convert = (time, timezone, language) => {
    moment.locale(language || defaultLanguage)
    return moment(time, 'x')
        .tz(timezone)
}

// Converts the given Unix time to a date in the given timezone, and formats it in the given format and in the given
// language.
const format = (time, format, timezone, language) => {
    return convert(time, timezone, language)
        .format(format)
}

export {
    convert,
    defaultTimezone,
    format,
    timezones
}



// WEBPACK FOOTER //
// ./src/helpers/timezones.js